import { Box } from '@mui/material';
import ModalPopup from 'components/molecules/ModalPopup';
import paymentError from 'assets/svg/payment-error.svg';
import { MediumText } from 'components/atoms/Typography';
import { BasicButton } from 'components/atoms/Buttons';
import { useRouting } from 'services/routing';
import useTranslation from 'next-translate/useTranslation';

interface IUnsuccessfulPaymentPopupProps {}

const UnsuccessfulPaymentPopup = ({}: IUnsuccessfulPaymentPopupProps) => {
    const routing = useRouting();
    const { t } = useTranslation('common');

    const handleClose = () => {
        routing.replace({ queries: { onlinePayment: false } });
    };

    return (
        <ModalPopup open={true} handleClose={handleClose}>
            <Box
                width={{ xs: '90vw', sm: '80vw', md: '70vw', lg: '50vw' }}
                height="70vh"
                sx={{
                    background: `url(${paymentError}) 50% 40% no-repeat`,
                }}
                display="flex"
                flexDirection="column"
                alignItems="center"
                position="relative"
            >
                <Box position="absolute" top="65%" display="flex" flexDirection="column" alignItems="center">
                    <MediumText semibold>{t('paymentError')}!</MediumText>
                    <Box mt={2}>
                        <MediumText>{t('unsuccessfulPayment')}</MediumText>
                    </Box>
                    <Box mt={5}>
                        <BasicButton onClick={handleClose}>
                            <MediumText>{t('closeAndFix')}</MediumText>
                        </BasicButton>
                    </Box>
                </Box>
            </Box>
        </ModalPopup>
    );
};

export default UnsuccessfulPaymentPopup;
